<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane  key="1">
        <span slot="tab">
          <g-wiki keyValue="WIKI_APOVOL"/>
          APORTES VOLUNTARIOS
        </span>
        <g-master name="apv"
                  :endpoint="master.endpoint"
                  :tableSetup="master.tableSetup"
                  :modalFieldsSetup="master.modalFieldsSetup"
                  :beforeSend="master.beforeSend"
                  :actions="master.actions"
                  @action="masterAction"
                  modalWidth="80%"
        >
          <span slot="estadoRenderer" slot-scope="{text}">
                        <a-tag
                          :color="text==='INACTIVO' ? 'red' : (text === 'ACTIVO' ? 'blue' : 'red')">{{text}}</a-tag>
          </span>
          <template slot="masterModal" slot-scope="{record}">
            <a-row :gutter="[16,16]">
              <a-col v-bind="colOptions">
                <g-lookup :label="$t('Empleado')"
                          :formItemConfig="fiOptions"
                          ref="empleado"
                          endpoint="empleados_en_reqliquidacion"
                          :decorator="['id_emp', { rules: [{ required: true, message: 'Valor requerido' }] }]">
                </g-lookup>
              </a-col>

              <a-col v-bind="colOptions">
                <g-dropdown endpoint="hierarchy_lookup"
                            style="width: 100%"
                            :label="$t('Tipo de entidad')"
                            :formItemConfig="fiOptions"
                            :decorator="['ent_type', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                            :params="tipo_entidad"
                            :selectedObj.sync="tipoEntidadSeleccionada"
                >
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown v-bind="fiOptions"
                            endpoint="ent_type"
                            :label="$t('Entidad')"
                            :formItemConfig="fiOptions"
                            :params="entidadSeleccionada()"
                            ref="entidad"
                            :selectedObj.sync="nombreEntidad"
                            :decorator="['ent_id', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                >
                </g-dropdown>
              </a-col>

              <a-col v-bind="colOptions">
                <g-lookup :label="$t('Concepto')"
                          :formItemConfig="fiOptions"
                          endpoint="coc"
                          ref="concepto"
                          :decorator="['id_coc', { rules: [{ required: true, message: 'Valor requerido' }] }]">
                </g-lookup>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Número de cuenta')">
                  <a-input
                    v-decorator="['cuenta_numero', { rules: [{ required: false }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha inicial')">
                  <a-date-picker style="width: 100%"
                                 type="date"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['date_ini', { rules: [{ required: false }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha final')">
                  <a-date-picker style="width: 100%"
                                 type="date"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['date_end', { rules: [{ required: false }] }]"/>
                </a-form-item>
              </a-col>

              <a-col v-bind="colOptions">
                <g-dropdown v-bind="fiOptions"
                            endpoint="hierarchy_lookup"
                            :label="$t('Estado')"
                            :formItemConfig="fiOptions"
                            :decorator="['status', { rules: [{ required: false}], initialValue: 'ACT' }]"
                            :params="estado">
                </g-dropdown>
              </a-col>
            </a-row>
          </template>
        </g-master>
      </a-tab-pane>
    </a-tabs>
    <template>
      <a-modal v-model="visible" title="Tiempo límite" :footer="null">
        <a-result status="warning"
                  title="La fecha de Novedad ha caducado para el Calendario de Nomina Activo, por favor consulte su administrador HRO">
          <template #extra>
            <a-button @click="handleOk" type="primary">
              Cerrar
            </a-button>
          </template>
        </a-result>
      </a-modal>
    </template>
  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    data () {
      return {
        visible: false,
        nombreEntidad: {},
        id_t_legal_entity: '',
        nombreEntidadSeleccionada: '',
        estado: {
          h_lookup_type: 'ESTADO_ACT_INA',
          use_code: true
        },
        tipo_entidad: {
          h_lookup_type: 'TIPO_ENTIDAD',
          use_code: true
        },
        tipoEntidadSeleccionada: {},
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        master: {
          actions: [],
          endpoint: 'emp_co_fvol',
          tableSetup: {
            customSlots: ['estadoRenderer'],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'ID empleado', dataIndex: 'id_emp', sorter: true},
              {title: 'Nombre completo', dataIndex: 'nombre_empleado', sorter: true},
              {title: 'ID del concepto', dataIndex: 'id_coc', sorter: true},
              {title: 'Concepto', dataIndex: 'nombre_concepto', sorter: true},
              {title: 'Tipo de entidad', dataIndex: 'ent_type_desc', sorter: true},
              {title: 'ID de la entidad', dataIndex: 'ent_id', sorter: true},
              {title: 'Nombre de entidad', dataIndex: 'ent_name', sorter: true},
              {title: 'Número de cuenta', dataIndex: 'cuenta_numero', sorter: true},
              {title: 'Fecha inicial', dataIndex: 'date_ini_desc', sorter: true},
              {title: 'Fecha final', dataIndex: 'date_end_desc', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'status_desc',
                sorter: true,
                width: 130,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              }
            ]
          },
          modalFieldsSetup: [
            {name: 'id_emp'},
            {name: 'ent_type'},
            {name: 'ent_id'},
            {name: 'id_coc'},
            {name: 'cuenta_numero'},
            {name: 'date_ini'},
            {name: 'date_end'},
            {name: 'status'}
          ]
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.limiteRegistroNovedad()
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'masterEdit':
            this.id_t_legal_entity = action.record.id_t_legal_entity
            this.$nextTick(() => {
              if (!JsUtils.isEmpty(action.record.id_emp)) {
                this.$refs.empleado && this.$refs.empleado.handleSearch(action.record.id_emp)
              }
              if (!JsUtils.isEmpty(action.record.id_coc)) {
                this.$refs.concepto && this.$refs.concepto.handleSearch(action.record.id_coc)
              }
            })
            if (!JsUtils.isEmpty(action.record.ent_id)) {
              this.tipoEntidadSeleccionada = {value: action.record.ent_type}
              this.entidadSeleccionada()
            }

            break
        }
      },
      handleOk () {
        this.visible = false
      },
      limiteRegistroNovedad () {
        if (this.$userIsInrol('RightHand') || this.$userIsInrol('Management') || this.$userIsInrol('AdminNomina')) {
          this.master.actions.push({
            name: 'masterCreate',
            text: 'Crear',
            permisos: [],
            props: {icon: 'plus', type: 'button'},
            fnVisible: () => !this.$userIsInrol('Query')
          })
        } else {
          this.httpClient.getInstance().get('tiempo_limite')
            .then(response => {
              if (response.data[0].tiempolimite !== '1') {
                this.visible = true
                this.master.actions.splice(0)
              } else {
                this.master.actions.push({
                  name: 'masterCreate',
                  text: 'Crear',
                  permisos: [],
                  props: {icon: 'plus', type: 'button'},
                  fnVisible: () => !this.$userIsInrol('Query')
                })
              }
            })
            .catch(() => {
              Mensajes.error('Error', 'No fue posble cargar el tiempo límite para registrar una novedad')
            })
        }
      },
      entidadSeleccionada () {
        if (!JsUtils.isEmpty(this.tipoEntidadSeleccionada.value) && !JsUtils.isEmpty(this.tipoEntidadSeleccionada)) {
          return {
            ent_type: this.tipoEntidadSeleccionada.value,
            use_ent_id: true
          }
        } else {
          return {
            id_emp: -1
          }
        }
      }
    },
    watch: {
      nombreEntidad () {
        this.nombreEntidadSeleccionada = this.nombreEntidad.text
        this.id_t_legal_entity = this.nombreEntidad.value
      }
    },
    computed: {

    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Novedades/EmpCoFvol.vue